import { useSnackbar } from "notistack";
import React, { useState } from "react";
import Dropzone from "react-dropzone";
import { BsDownload } from "react-icons/bs";
import { MdOutlineClear } from "react-icons/md";
import { getFileExtension } from "../../../../../utility/bulkDataModifier";
import { CustomButton } from "../../../../components/customButton/CustomButton";
import CustomModal from "../../../../components/customModal/CustomModal";
import { BulkFile, BulkFileUpload } from "../../../../resources/assetsManager";
import {
  BLACK_COLOR,
  LIGHT_GREY_BG_MODAL,
} from "../../../../resources/colorsManager";
import "../index.css";
import DisplayBulk from "./DisplayBulk";
import Papa from "papaparse";
function AddCustomerBulk({
  width,
  height,
  passRawData,
  step,
  onClickSubmit,
  onClickClear,
  loading = false,
  onClickDownloadSample,
}) {
  const [fileName, setFileName] = useState("");
  const { enqueueSnackbar } = useSnackbar();
  const [showFileName, setShowFileName] = useState(false);
  const [file, setFile] = useState("");
  const [showPreiveiewModal, setShowPreiveViewModal] = useState(false);

  const handleDrop = (acceptedFiles) => {
    if (acceptedFiles && acceptedFiles.length <= 1) {
      if (getFileExtension(acceptedFiles[0].name) === "csv") {
        setFileName(acceptedFiles[0]?.name);
        setShowFileName(true);
        setFile(acceptedFiles[0]);
        const reader = new FileReader();
        console.log(reader, "red");
        handleFileUpload(acceptedFiles[0]);
      } else {
        enqueueSnackbar("Invalid file type , please select only csv file.", {
          variant: "error",
        });
      }
    } else {
      enqueueSnackbar("Select only one file to upload", {
        variant: "error",
      });
    }
  };

  const handleFileUpload = (e) => {
    if (e) {
      Papa.parse(e, {
        header: false,
        skipEmptyLines: true,
        complete: (val) => {
          passRawData(val);
        },
      });
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        maxWidth: 350,
      }}
    >
      <p
        style={{
          color: "black",
          fontFamily: "Roboto",
          fontSize: 15,
          fontWeight: "500",
        }}
      >
        Upload File
      </p>
      {step === 1 ? (
        <>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              borderBottom: "4px solid dodgerblue",
              marginBottom: 100,
              alignItems: "center",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <img
                src={BulkFile}
                style={{
                  width: 22,
                  height: 22,
                }}
              />
              <p
                style={{
                  color: BLACK_COLOR,
                  padding: 0,
                  margin: 6,
                  textAlign: "center",
                  marginLeft: 20,
                  fontSize: 14,
                  wordBreak: "break-all",
                }}
              >
                {showFileName
                  ? fileName.length > 35
                    ? fileName.slice(0, 35) + "..."
                    : fileName
                  : ""}
              </p>
            </div>
            <MdOutlineClear
              style={{
                color: "dodgerblue",
                cursor: "pointer",
              }}
              size={20}
              onClick={() => {
                setShowFileName(false);
                setFileName("");
                setFile("");
                onClickClear();
              }}
            />
          </div>
        </>
      ) : (
        <div
          className="box"
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            padding: "10px 15px ",
            cursor: "pointer",
            height: "100%",
            minHeight: 200,
            backgroundColor: LIGHT_GREY_BG_MODAL,
          }}
        >
          <Dropzone
            onDrop={handleDrop}
            acceptedFiles={[".csv", ".xls", ".xlsz"]}
          >
            {({
              getRootProps,
              getInputProps,
              isDragActive,
              isDragAccept,
              isDragReject,
            }) => {
              const additionalClass = isDragAccept
                ? "accept"
                : isDragReject
                ? "reject"
                : "";

              return (
                <div
                  style={{
                    height: width > 600 ? 200 : 250,
                    borderWidth: "2px 2px 2px 2px",
                    borderStroke: "1px",
                    borderColor: "#5F5E9F",
                    borderRadius: 10,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                  }}
                  {...getRootProps({
                    className: `dropzone ${additionalClass}`,
                  })}
                >
                  <img
                    src={BulkFileUpload}
                    style={{
                      width: 70,
                      height: 70,
                    }}
                  />
                  <p
                    style={{
                      fontSize: 15,
                      padding: 0,
                      margin: 0,
                      fontWeight: "500",
                      color: "#7E7E7E",
                      fontFamily: "Roboto",
                    }}
                  >
                    Drag and drop files here to upload
                  </p>

                  <div
                    style={{
                      marginTop: 20,
                    }}
                  >
                    <label
                      htmlFor="file-upload"
                      className="custom-file-upload"
                      style={{
                        borderRadius: 7,
                        padding: "10px 20px 10px 20px",
                        fontSize: 14,
                        fontWeight: "bold",
                        backgroundColor: "#3783FB",
                        cursor: "pointer",
                      }}
                    >
                      Choose File
                    </label>
                  </div>
                </div>
              );
            }}
          </Dropzone>
        </div>
      )}

      {showPreiveiewModal && (
        <CustomModal
          open={showPreiveiewModal}
          onClose={() => {
            setShowPreiveViewModal(false);
          }}
        >
          <DisplayBulk />
        </CustomModal>
      )}
      {step === 0 && (
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            margin: "10px 0px",
            cursor: "pointer",
          }}
          onClick={onClickDownloadSample}
        >
          <BsDownload
            color="dodgerblue"
            style={{
              marginRight: 10,
            }}
          />
          <p
            style={{
              color: "dodgerblue",
              fontSize: 15,
              padding: 0,
              margin: 0,
            }}
          >
            Download Template
          </p>
        </div>
      )}

      <CustomButton
        title="Submit"
        styles={{
          width: "100%",
          border: "none",
          marginTop: 10,
          borderRadius: 4,
          height: 45,
        }}
        loading={loading}
        onClick={() => {
          showFileName && onClickSubmit();
        }}
      ></CustomButton>
    </div>
  );
}

export default AddCustomerBulk;
